// extracted by mini-css-extract-plugin
module.exports = {"label":"_3dos2xW5KLTowuwwukaXqh","active":"_2wXc8295ybsKaHWI3quuGn"};